/// <amd-module name="VSSUI/Components/ComboBox/ComboBox" />
import * as React from "react";

import { ComboBox as FabricComboBox } from "OfficeFabric/ComboBox";
import { IComboBoxProps } from "./ComboBox.Props";
import { css } from "VSSUI/Util";

/** @deprecated Please use import { Dropdown } from "VSSUI/Dropdown" */
export const ComboBox: React.StatelessComponent<IComboBoxProps> = (props: IComboBoxProps) => {
    return (
        <FabricComboBox
            {...props}
            autoComplete={props.autoComplete ? "on" : "off"}
            className={css(props.className, "vss-ComboBox--container")}
            useComboBoxAsMenuWidth={true}
        />
    );
};
